import { useQuery } from '@tanstack/react-query';
import { API } from '@/utils/API';

export interface StatusCounts {
  draft: number;
  submitted: number;
  under_review: number;
  approved: number;
  expiring_soon: number;
}

const EMPTY_COUNTS: StatusCounts = {
  draft: 0,
  submitted: 0,
  under_review: 0,
  approved: 0,
  expiring_soon: 0,
};

export const useStatusCounts = () => {
  const { data, isLoading } = useQuery<StatusCounts>({
    queryKey: ['dashboard', 'statusCounts'],
    queryFn: () =>
      API.authenticated.fetch('/dashboard/submissions').then(r => r.json()),
  });

  return { statusCounts: data ?? EMPTY_COUNTS, isLoading };
};
